import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { HttpHeaders } from '@angular/common/http';
import { AppConfig } from '../config/app.config';
import { Observable } from 'rxjs';
import { Http } from '@angular/http';


const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  })
};

@Injectable()
export class ChangeIssuerService {
  constructor(private http: Http, private config: AppConfig) { }
  private apiUrl: string = this.config.get('apiUrl') + 'Admin';



  changeIssuer(loggedInUser: string, oldUser: string, newUser: string, tbl: string, PartPI: string, PartSI: string, MHNO_PM: string, MHNO_DU: string, oldIssuerUserId: string, oldApproverUserId: string): Observable<any> {

    return this.http.post(`${this.apiUrl}/ChangeIssuer/?loggedInUser=${loggedInUser}&oldIssuerId=${oldUser}&newIssuerId=${newUser}&tbl=${tbl}&PartPI=${PartPI}&PartSI=${PartSI}&oldIssuerUserId=${oldIssuerUserId}&oldApproverUserId=${oldApproverUserId}&MHNO_PM=${MHNO_PM}&MHNO_DU=${MHNO_DU}`, httpOptions);

  }

}



// WEBPACK FOOTER //
// C:/Users/SHR6M3/Development/PackITWebGui/src/app/change-issuer/change-issuer.service.ts